import _ from 'lodash';
import moment from 'moment';
import { channelOutletMapping, CONSTANT } from './constant';

const getValue = value => value || '-';

/* eslint-disable */
const setConstant = (constantKey, data, k) => {
  let tempData = _.keyBy(data, k);
  for (let key in tempData) {
    CONSTANT[constantKey][key] = tempData[key].id;
  }
};
/* eslint-enable */
export { getValue, setConstant };

export const isEmpty = value => {
  if (value === undefined || value === null || value === '') {
    return true;
  }
  return false;
};

export const hasLength = (...args) => {
  const empty = element => !(element && element.length);
  return !args.every(empty);
};

export const getFormattedDate = (dateString, format = 'YYYY-MM-DD') => {
  return dateString && moment(dateString).format(format);
};

export const getFormattedDateUTC = (dateString, format = 'YYYY-MM-DD') => {
  return dateString && moment.utc(dateString).format(format);
};

export const getFormattedUnixDate = (dateString, format = 'YYYY-MM-DD') => {
  return (
    dateString &&
    moment
      .unix(dateString)
      .utc()
      .format(format)
  );
};

export const camel2title = camelCase => _.startCase(camelCase);

export const getMappedChannel = outletValue => {
  let result = '';
  Object.keys(channelOutletMapping).forEach(channel => {
    if (channelOutletMapping[channel].includes(outletValue)) result = channel;
  });
  return result;
};

export const sortedObjects = (arr, name) =>
  arr.sort((a, b) =>
    // eslint-disable-next-line no-nested-ternary
    a[name] > b[name] ? 1 : b[name] > a[name] ? -1 : 0
  );
